import { Camera, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import { compressImage, MAX_PHOTOS } from "../photos";

export const PhotoPicker = ({ photos, setPhotos, min = 0, testid = "photo-picker", cameraOnly = false }) => {
  const addPhotos = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    const room = MAX_PHOTOS - photos.length;
    if (room <= 0) {
      toast.error(`Maximum ${MAX_PHOTOS} photos per visit`);
      return;
    }
    if (files.length > room) toast.warning(`Only ${room} more photo${room === 1 ? "" : "s"} allowed (max ${MAX_PHOTOS})`);
    for (const f of files.slice(0, room)) {
      try {
        const dataUrl = await compressImage(f);
        setPhotos((p) => (p.length < MAX_PHOTOS ? [...p, dataUrl] : p));
      } catch {
        toast.error(`Could not read ${f.name}`);
      }
    }
  };

  return (
    <div className="space-y-2" data-testid={`${testid}-picker`}>
      <label className="flex h-12 cursor-pointer items-center justify-center gap-2 rounded-md border border-dashed border-border text-sm font-semibold text-muted-foreground" data-testid={testid}>
        <Camera size={18} weight="bold" /> Add photo{photos.length > 0 ? ` (${photos.length})` : ""}
        <input type="file" accept="image/*" multiple={!cameraOnly} capture={cameraOnly ? "environment" : undefined} className="hidden" onChange={addPhotos} data-testid={`${testid}-input`} />
      </label>
      {photos.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid={`${testid}-thumbnails`}>
          {photos.map((p, i) => (
            <div key={`${i}-${p.length}`} className="relative">
              <img src={p} alt={`Photo ${i + 1}`} className="h-16 w-16 rounded-md object-cover" />
              <button type="button" data-testid={`${testid}-del-${i}`} onClick={() => setPhotos((cur) => cur.filter((_, j) => j !== i))}
                className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-destructive text-destructive-foreground">
                <X size={12} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}
      {min > 0 && photos.length < min && (
        <p className="text-xs font-semibold text-muted-foreground" data-testid={`${testid}-min-hint`}>
          Add at least {min} photo{min === 1 ? "" : "s"} to complete ({photos.length}/{min})
        </p>
      )}
      {photos.length >= MAX_PHOTOS && <p className="text-xs font-semibold text-muted-foreground">Maximum {MAX_PHOTOS} photos reached</p>}
    </div>
  );
};
